/* Shows fixed GBP offer values (e.g. care kit worth £60) in the visitor's currency, using Shopify's live rate. */
(function () {
  var c = window.Shopify && window.Shopify.currency;
  if (!c || !c.active || c.active === 'GBP') return;
  var rate = parseFloat(c.rate) || 1;
  var scope = '.announcement-bar, .ls-offer, .ls-promise, .ls-cart, .ls-cart__reasons, .ls-card-offer, .banner__box, .ls-kit-line';
  function fmt(gbp) {
    var v = Math.round((gbp * rate) / 5) * 5;
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: c.active, maximumFractionDigits: 0 }).format(v); }
    catch (e) { return c.active + ' ' + v; }
  }
  function run(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, list = [];
    while ((n = w.nextNode())) {
      if (/\u00a3\s?\d/.test(n.nodeValue) && n.parentElement && n.parentElement.closest(scope)) list.push(n);
    }
    list.forEach(function (t) {
      t.nodeValue = t.nodeValue.replace(/\u00a3\s?(\d+(?:\.\d+)?)/g, function (m, g) { return fmt(parseFloat(g)); });
    });
  }
  function start() {
    run(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (x) { if (x.nodeType === 1) run(x); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
